var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.24139 8.92638C2.85089 8.57319 2.85089 8.00056 3.24139 7.64736C3.63189 7.29418 4.26509 7.29418 4.65559 7.64736L9.94849 12.4343L15.2414 7.64736C15.6319 7.29418 16.2651 7.29418 16.6556 7.64736C17.0461 8.00056 17.0461 8.57319 16.6556 8.92638L10.6556 14.3528C10.2651 14.706 9.63191 14.706 9.24138 14.3528L3.24139 8.92638Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChevronDown);
export default __webpack_public_path__ + "static/media/icon-chevron-down.b5ddd9d64be6e8088d47ea5efba10587.svg";
export { ForwardRef as ReactComponent };